import React from "react";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Button from "../../core-components/theme/components/Button/Button";
import { Neutrals } from "../../core-components/theme/color-palette/colors";

interface ButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  containerProps?: any;
  saveButtonProps?: any;
  cancelButtonProps?: any;
  cancelLabel?: any,
  saveLabel?: any,
  disableSubmit?: boolean
}

const ButtonStack: React.FC<ButtonsProps> = ({
  containerProps,
  saveButtonProps,
  cancelButtonProps,
  disableSubmit,
  onSave,
  onCancel,
  cancelLabel,
  saveLabel,
}) => {
  const { t } = useTranslation();
  const resolvedCancelLabel = cancelLabel ?? t('common.cancelUpper', 'CANCEL');
  const resolvedSaveLabel = saveLabel ?? t('common.submitUpper', 'SUBMIT');
  return (
    <Stack {...containerProps}>
      <Button
        variant="outlined"
        size='large'
        onClick={onCancel}
        {...cancelButtonProps}
      >
        <Typography variant="body" lineHeight="24px" sx={{color: (cancelButtonProps?.cancelButtonColor || Neutrals[900])}}>
          {resolvedCancelLabel}
        </Typography>
      </Button>
      {
        !disableSubmit &&
        <Button
          variant="contained"
          onClick={onSave}
          size='large'
          {...saveButtonProps}
        >
          <Typography variant="body" lineHeight="24px" color="white">
            {resolvedSaveLabel}
          </Typography>
        </Button>
      }
    </Stack>
  )
}

export default ButtonStack;